export default {
  getDefaultState: () => {
    return {
      movements: [],
      isCallingMovements: false,
      movementsCurrentPage: 1,
      movementsLastPage: 1,
      isCallingOffice: false,
      officeBalanceInformation: null,
      isCallingTokenizedCards: false,
      expenseDashboardData: [],
      expenseDataFilters: {},
      tokenizedCards: []
    }
  }
}
